<template>
  <q-dialog :visible="isVisible" :title="title" width="830px" :innerScroll="false" :showFooter="false" @close="onCancel" v-esc-close>
    <div class="content" v-loading="loading" v-if="textForm.time">
      <div class="label-name">
        <div>回退人：</div>
        <div>{{ textForm.name }}</div>
      </div>
      <div class="label-name">
        <div>回退时间：</div>
        <div>{{ textForm.time }}</div>
      </div>
      <div v-if="isVision">
        <div >
        <div class="label-name">视觉拍摄原图：</div>
        <div class="img-box">
          <div v-for="(item, index) in visionImgList" :key="index" @click="visionIndex = index">
            <el-image :src="item" alt="" :preview-src-list="visionImgList" :initial-index="visionIndex"></el-image>
          </div>
        </div>
      </div>
      <div v-if="isVision && supplyFileList.length">
        <div class="label-name">视觉拍摄补充原图：</div>
        <div class="img-box">
          <div v-for="(item, index) in supplyFileList" :key="index" @click="supplyIndex = index">
            <el-image :src="item" alt="" :preview-src-list="supplyFileList" :initial-index="supplyIndex"></el-image>
          </div>
        </div>
      </div>
      </div>
      <div v-else>
        <div class="label-name">正面图片：</div>
        <div class="img-box">
          <div v-for="(item, index) in positiveImgList" :key="index" @click="positiveIndex = index">
            <el-image :src="item" alt="" :preview-src-list="positiveImgList" :initial-index="positiveIndex"></el-image>
          </div>
        </div>
        <div class="label-name">背面图片：</div>
        <div class="img-box">
          <div v-for="(item, index) in backImgList" :key="index" @click="backIndex = index">
            <el-image :src="item" alt="" :preview-src-list="backImgList" :initial-index="backIndex"></el-image>
          </div>
        </div>
        <div class="label-name">其他补充图片：</div>
        <div class="img-box">
          <div v-for="(item, index) in otherImgList" :key="index" @click="otherIndex = index">
            <el-image :src="item" alt="" :preview-src-list="otherImgList" :initial-index="otherIndex"></el-image>
          </div>
        </div>
      </div>
    </div>
    <div class="empty" v-loading="loading" v-else>暂无回退记录数据</div>
    <div class="footer">
      <el-button @click="onCancel">关闭</el-button>
    </div>
  </q-dialog>
</template>

<script>
export default {
  name: 'CRUDEdit',
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    recordForm: Object,
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    title() {
      return '回退记录';
    },
    name() {
      return this.$store.state.user.name;
    },
    isVision() {
      return this.recordForm.dataCategory == 1;
    },
  },
  data() {
    return {
      loading: false,
      visionIndex: 0,
      supplyIndex: 0,
      positiveIndex: 0,
      backIndex: 0,
      otherIndex: 0,
      visionImgList: [
        // 'https://ecocs.quanyou.com.cn/goods-new-stg/%E6%96%B0%E5%93%81%E4%B8%8A%E6%9E%B6/%E4%BF%AE%E7%89%87/%E6%96%B0/600620%E6%A8%A1%E5%9D%97%E4%B9%A6%E6%9F%9CB5136N%23/%E6%9C%80%E6%96%B0/%E5%A4%A7%E7%89%87/%E5%A4%A7%E7%89%871.jpg',
        // 'https://eco.quanyou.com.cn/dsglfiles/新品上架/修片/旧/修片/2023年/12月/102582AⅠ皮乳胶沙发 102582A-1皮沙发 DW1116矮圆茶几A+高边几组合 DW1160岛台+餐桌+DW1155餐椅  修片+李阳+璟禾映画 2023.12.19/大片/RAW12566.jpg',
        // 'https://eco.quanyou.com.cn/dsglfiles/新品上架/修片/旧/修片/2023年/12月/102582AⅠ皮乳胶沙发 102582A-1皮沙发 DW1116矮圆茶几A+高边几组合 DW1160岛台+餐桌+DW1155餐椅  修片+李阳+璟禾映画 2023.12.19/大片/RAW12572.jpg',
        // 'https://eco.quanyou.com.cn/dsglfiles/新品上架/修片/旧/修片/2023年/12月/102582AⅠ皮乳胶沙发 102582A-1皮沙发 DW1116矮圆茶几A+高边几组合 DW1160岛台+餐桌+DW1155餐椅  修片+李阳+璟禾映画 2023.12.19/大片/RAW12671.jpg',
        // 'https://eco.quanyou.com.cn/dsglfiles/新品上架/修片/旧/修片/2023年/12月/102582AⅠ皮乳胶沙发 102582A-1皮沙发 DW1116矮圆茶几A+高边几组合 DW1160岛台+餐桌+DW1155餐椅  修片+李阳+璟禾映画 2023.12.19/大片/RAW12671.jpg',
        // 'https://eco.quanyou.com.cn/dsglfiles/新品上架/修片/旧/修片/2023年/12月/102582AⅠ皮乳胶沙发 102582A-1皮沙发 DW1116矮圆茶几A+高边几组合 DW1160岛台+餐桌+DW1155餐椅  修片+李阳+璟禾映画 2023.12.19/大片/RAW12671.jpg',
      ],
      supplyFileList: [],
      positiveImgList: [],
      backImgList: [],
      otherImgList: [],
      textForm: {},
    };
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    async init() {
      this.loading = true;
      this.$q.newProduct
        .productCheckImgRollbackRecord({ data: this.recordForm })
        .then(({ data }) => {
          this.textForm = {
            name: data.length ? data[0].rollbackUserName : '',
            time: data.length ? data[0].rollBackTime : '',
          };
          //视觉包括 视觉拍摄 和 补充拍摄 type都为1 通过supplement区分
          let visionImg = data.filter((v) => v.dataType == 1);
          this.visionImgList = this.supplyFilter(visionImg, 0);
          this.supplyFileList = this.supplyFilter(visionImg, 1);
          this.positiveImgList = this.getImg(data, 2);
          this.backImgList = this.getImg(data, 3);
          this.otherImgList = this.getImg(data, 4);
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    getImg(list, type) {
      const imgList = list.find((v) => v.dataType == type);
      return imgList ? imgList.imgUrls : [];
    },
    supplyFilter(list, type) {
      const imgList = list.find((v) => v.supplement == type);
      return imgList ? imgList.imgUrls : [];
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="stylus" scoped>
.content {
  box-sizing: border-box;
  max-height: 70vh;
  overflow-y: auto
  padding: 15px
}
.empty {
  height: 258px
  display: flex
  justify-content: center
  align-items: center
}

.label-name {
  font-size: 14px
  margin: 15px 0
  display: flex
  align-items: center
  justify-content: space-between
}

.img-box {
  display: flex

    div {
      cursor: pointer
      width: 120px
      height: 120px
      margin-right: 10px
    }
}

.footer {
  text-align: center
  margin-top: 30px
}

>>> .el-dialog {
  margin-top: 50px !important
}
</style>
